import Theme from '@engine/features/dashboard/top_5/dashboard_top5_theme'; // Reorder Styles to match approved, not_approved & etc.

var styles = [Theme.styles[1], Theme.styles[3], Theme.styles[2], Theme.styles[0], Theme.styles[4]];
export default {
  styles: styles
};